export default "__VITE_ASSET__B0M8znRI__"